import React from 'react'
import styles from '../../styles'
import MuiButton from '@mui/material/Button'
import { makeStyles } from 'tss-react/mui'
import { buttonSize } from './enums/buttonEnum'

const useStyles = makeStyles()((theme) => ({
	...styles(theme),
	buttonStyle: {
		borderRadius: 0,
		textTransform: 'inherit'
	},
	bigButton: {
		width: '100%',
		height: 64,
		padding: '23px 40px'
	},
	mediumButton: {
		minHeight: 48,
		padding: '15px 24px'
	},
	smallButton: {
		width: '100%',
		height: 40,
		padding: 10
	},
	fullWidth: {
		width: '100%'
	}
}))

interface ModelButton {
	background: string,
	color: string,
	textStyle: string,
	children: React.ReactNode,
	onClick?: () => void,
	disabled?: boolean,
	size?: buttonSize.small | buttonSize.medium | buttonSize.big,
	type?: 'submit' | 'reset' | 'button',
	border?: string | null,
	ariaLabel?: string
	fullWidth?: boolean,
	buttonStyle?: string
}

type ButtonProps = ModelButton

const Button: React.FC<ButtonProps> = (
	{
		background,
		color,
		textStyle,
		children,
		onClick,
		disabled = false,
		size = buttonSize.medium,
		type = 'submit',
		border,
		ariaLabel,
		fullWidth = false,
		buttonStyle
	}
) => {
	const { classes, cx } = useStyles()

	const btnClass = cx(
		classes[background as keyof typeof styles],
		classes[textStyle as keyof typeof styles],
		{
			[classes.bigButton]: size === buttonSize.big,
			[classes.mediumButton]: size === buttonSize.medium,
			[classes.smallButton]: size === buttonSize.small,
			[classes[border as keyof typeof styles]]: border,
			[classes.fullWidth]: fullWidth
		},
		classes[color as keyof typeof styles],
		classes.buttonStyle,
		buttonStyle
	)

	return (
		<MuiButton
			onClick={(e) => {
				if (onClick) {
					e.stopPropagation()
					onClick()
				}
			}}
			className={btnClass}
			disabled={disabled}
			type={type}
			aria-label={ariaLabel}
		>
			{children}
		</MuiButton>
	)
}

export default Button
